<template>
  <div class="">
    <p class="msg">{{message}}</p>
    <template v-if="list?.length">
        <div class="list" >
            <div class="item" v-for="item in list" :key="item.id">
                <p>{{item.name}}</p>
                <div class="pl20" v-for="child in item.child" :key="child.id">
                    <p>{{child.name}}</p>
                </div>
            </div>
        </div>
    </template>
    <div class="btns">
        <el-button v-if="onText" @click="()=>handleClick(true)"><span class="btn-text" >{{onText}}</span></el-button>
        <el-button v-if="closeText" type="primary" @click="()=>handleClick(false)"><span class="btn-text">{{closeText}}</span></el-button>
    </div>
  </div>
</template>

<script>
export default {
    props: [ 
        'cbs' , 
        'message', 
        'onText', 
        'closeText',
        'list'
    ],
    methods: {
        handleClick(type) {
            this.cbs.onSubmit(type)
        }
    }
}
</script>

<style lang="scss" scoped>
.list {
    max-height: 360px;
    overflow: auto;
}
.btns {
    padding-top: 50px;
    text-align: center;
    .btn-text {
        padding: 0 20px;
    }
}
.msg {
    color: red;
    font-weight: bold;
    font-size: 16px;
    line-height: 26px;
}
</style>